import React, { useState, useEffect } from "react";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

import contentfulApi from "../../utils/contentful";
import { callToLearnMoreButtonClicked } from "utils/segment";

import PageHeader from "../../components/PageHeader";
import Row from "../../components/Row";
import Col from "../../components/Col";
import Button from "../../components/Button";
import Container from "../../components/Container";
import GetStarted from "../../components/GetStarted";

import Article from "../Press/Article";

import VideoGalleryImage from "../../assets/videoGalleryHeader.png";

const VideoGallery = (props) => {
  const [data, setData] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    contentfulApi
      .getEntries({
        content_type: "video",
      })
      .then((response) => {
        setData(Object.assign(response.items));
        setDataLoaded(true);
      });
  }, [props]);

  if (!dataLoaded) {
    return null;
  }

  return (
    <div className="press">
      <PageHeader>
        <Row>
          <Col md={5}>
            <h1>Video Gallery</h1>
            <hr />
            <p>
              Watch Papa's videos below to see how we are impacting our
              communities.
            </p>

            <div className="hidden-desktop text-center text-uppercase font-600 mb-10">
              Call to learn more
            </div>
            <Button
              href="tel:+1-800-348-7951"
              onClick={callToLearnMoreButtonClicked}
            >
              <span className="hidden-mobile">Call to learn more</span>{" "}
              1-800-348-7951
            </Button>
          </Col>
        </Row>

        <img
          src={VideoGalleryImage}
          alt="Papa"
          className="page-header__image video-gallery"
        />
      </PageHeader>

      <div className="press-articles">
        <Container>
          <div className="featured-article">
            <Row className="flex align-center">
              <Col md={6}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={data[0].fields.url}
                >
                  <img
                    src={
                      data[0].fields.thumbnail &&
                      data[0].fields.thumbnail.fields.file.url
                    }
                    alt="Featured article"
                    className="img-responsive"
                  />
                </a>
              </Col>

              <Col md={6}>
                <h3 className="mb-30">{data[0].fields.title}</h3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: documentToHtmlString(data[0].fields.description),
                  }}
                />

                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={data[0].fields.url}
                >
                  Watch
                </a>
              </Col>
            </Row>
          </div>

          <Row>
            {data.map((video, index) => (
              <Col md={3} key={`video_${index}`}>
                <a
                  href={video.fields.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Article
                    image={
                      video.fields.thumbnail &&
                      video.fields.thumbnail.fields.file.url
                    }
                  >
                    <h4 className="mb-10">{video.fields.title}</h4>

                    <div
                      className="mb-0"
                      dangerouslySetInnerHTML={{
                        __html: documentToHtmlString(video.fields.description),
                      }}
                    ></div>
                  </Article>
                </a>
              </Col>
            ))}
          </Row>

          {/* <div className="view-more text-center">
            <a href="#">View More</a>
          </div> */}
        </Container>
      </div>

      <GetStarted hideCall={true} />
    </div>
  );
};

export default VideoGallery;
